/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ActiveOfferApiResponse } from '../models/ActiveOfferApiResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class OffersService {
    /**
     * Get the live guest offer
     * The live offer marked "Show to guests", or null. Public. Not cached, so a paused offer stops showing on the next request.
     * @returns ActiveOfferApiResponse Guest offer fetched; data is null when there is none
     * @throws ApiError
     */
    public static offersControllerGetGuestOfferV1(): CancelablePromise<ActiveOfferApiResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/offers/guest',
        });
    }
}
